const d = (I, n, t, r, e) => {
  const T = t === "single", E = I.find((s) => s.value === n);
  if (E != null && E.isSelected && T)
    return;
  const u = (s, _) => {
    if (s.value === n && !s.isDisabled && !s.isLocked) {
      const S = _ ? !0 : !s.isSelected, c = { ...s, isSelected: S };
      return (!_ || !s.isSelected) && (r == null || r(c)), c;
    }
    return _ ? { ...s, isSelected: !1 } : s;
  };
  if (!(E != null && E.isDisabled)) {
    const s = I.map((_) => u(_, T));
    e(s);
  }
}, o = (I) => I.filter(({ isSelected: n }) => n), N = (I) => {
  var E;
  return I != null && I.description ? (E = I.description) != null && E.toString().includes(`
`) ? 78 : I != null && I.thumbnail ? 66 : I != null && I.entityColor ? 54 : 62 : 42;
};
export {
  N as getMenuItemHeight,
  o as getMenuSelectedItems,
  d as onItemClick
};
//# sourceMappingURL=index.es2482.js.map
